export default __webpack_public_path__ + "static/media/Ballroll_00381.b873e163.png";